module.exports = __webpack_public_path__ + "static/media/5.5cdea5b3.jpg";